'use client';

import CookieConsent from 'react-cookie-consent';
import { useTranslations } from 'next-intl';
import { Box } from '@mui/material';

const CookieBanner = () => {
  const t = useTranslations('CookieBanner');
  return (
    <CookieConsent
      location="bottom"
      buttonText={t('okBtn')}
      declineButtonText={t('rejectBtn')}
      enableDeclineButton
      cookieName="SailglobalWebsiteCookie"
      style={{
        background: '#2B373B',
        color: '#FFF',
        padding: '24px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      buttonStyle={{
        background: '#2563EB',
        color: '#FFF',
        fontSize: '14px',
        padding: '10px 12px',
        width: '120px',
        borderRadius: '8px',
      }}
      declineButtonStyle={{
        background: '#EF4444',
        color: '#FFF',
        fontSize: '14px',
        padding: '10px 12px',
        width: '120px',
        borderRadius: '8px',
      }}
      expires={365} // Cookie 的有效期（天）
      onAccept={() => {
        console.log('User accepted cookies');
      }}
      onDecline={() => {
        console.log('User declined cookies');
      }}
    >
      <Box
        sx={{
          fontSize: '16px',
          fontWeight: 700,
        }}
      >
        {t('notice')}
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          marginTop: '8px',
        }}
      >
        {t('title')}
      </Box>
    </CookieConsent>
  );
};

export default CookieBanner;
